import gql from "graphql-tag";

export default gql`query Documents($date:Date!) {
    documents(date:$date) {
        id    
        file {
            id
            referencelong
            department {
                id
            }
        }
        user {
            id
            name
        }
        templateRevision {
            id
            snippet {
                id
                name
                template {
                    id
                    code
                }
            }
        }
        timestamp
      }
  }`